import "./Privacy&Policy.css";
export default function PrivacyAndPolicy() {
  return (
    <>
      <div className="privacy-policy-main-container">
        <div className="privacy-policy-container">
          <div className="starting-point-container">
            <div className="privacy-policy-title">Privacy Policy</div>
            <div className="privacy-policy-description">
              This Privacy Policy governs the manner in which Hussme
              collects, uses, maintains and discloses information collected from
              users (each, a "User") of the https://www.hussme.com
              website ("Site"). This privacy policy applies to the Site and all
              products and services offered by Hussme.
            </div>
          </div>
          <div className="common-point-container">
            <div className="privacy-policy-normal-title">
              Personal identification information
            </div>
            <div className="privacy-policy-description">
              We may collect personal identification information from Users in a
              variety of ways, including, but not limited to, when Users visit
              our site, subscribe to the newsletter, fill out a form, and in
              connection with other activities, services, features or resources
              we make available on our Site. We may use your contact information
              to communicate with you about your orders, account activity, and
              other matters. Users may be asked for, as appropriate, name, email
              address, mailing address, phone number. Users may, however, visit
              our Site anonymously. We will collect personal identification
              information from Users only if they voluntarily submit such
              information to us. Users can always refuse to supply personally
              identification information, except that it may prevent them from
              engaging in certain Site related activities.
              <div className="privacy-blank-row"></div> All the above categories
              exclude text messaging originator opt-in data and consent; this
              information will not be shared with any third parties.
            </div>
          </div>
          <div className="common-point-container">
            <div className="privacy-policy-normal-title">
              Non-personal identification information
            </div>
            <div className="privacy-policy-description">
              We may collect non-personal identification information about Users
              whenever they interact with our Site. Non-personal identification
              information may include the browser name, the type of computer and
              technical information about Users means of connection to our Site,
              such as the operating system and the Internet service providers
              utilized and other similar information.
            </div>
          </div>

          <div className="common-point-container">
            <div className="privacy-policy-normal-title">
              Non-personal identification information
            </div>
            <div className="privacy-policy-subheading">
              How we use collected information
            </div>
            <div className="privacy-policy-description">
              <strong>Hussme </strong>collects and uses Users' personal
              information for the following purposes: <br />
            </div>
            <div className="privacy-policy-description">
              <ul className="privacy-policy-ul" type="1">
                <li className="privacy-policy-list">
                  <span className="privacy-policy-list-italic">
                    {" "}
                    To improve our Site{" "}
                  </span>{" "}
                  <br />
                  We continually strive to improve our website offerings based
                  on the information and feedback we receive from you.
                </li>
                <li className="privacy-policy-list">
                  <span className="privacy-policy-list-italic">
                    To improve customer service{" "}
                  </span>{" "}
                  <br />
                  Your information helps us to more effectively respond to your
                  customer service requests and support needs.
                </li>
                <li className="privacy-policy-list">
                  <span className="privacy-policy-list-italic">
                    {" "}
                    To process transactions{" "}
                  </span>{" "}
                  <br /> We may use the information Users provide about
                  themselves when placing an order only to provide service to
                  that order. We do not share this information with outside
                  parties except to the extent necessary to provide the service.
                </li>
                <li className="privacy-policy-list">
                  <span className="privacy-policy-list-italic">
                    {" "}
                    To send periodic emails{" "}
                  </span>{" "}
                  <br />
                  The email address Users provide will only be used to respond
                  to their inquiries, and/or other requests or questions. If
                  User decides to opt-in to our mailing list, they will receive
                  emails that may include company news, updates, related product
                  or service information, etc. If at any time the User would
                  like to unsubscribe from receiving future emails, we include
                  detailed unsubscribe instructions at the bottom of each email
                  or User may contact us via our Site.
                </li>
              </ul>
            </div>
          </div>
          <div className="common-point-container">
            <div className="privacy-policy-normal-title">
              How we protect your information
            </div>
            <div className="privacy-policy-description">
              We adopt appropriate data collection, storage and processing
              practices and security measures to protect against unauthorized
              access, alteration, disclosure or destruction of your personal
              information, username, password, transaction information and data
              stored on our Site.
            </div>
          </div>
          <div className="common-point-container">
            <div className="privacy-policy-normal-title">
              Sharing your personal information
            </div>
            <div className="privacy-policy-description">
              We do not sell, trade, or rent Users personal identification
              information to others. We may share generic aggregated demographic
              information not linked to any personal identification information
              regarding visitors and users with our business partners, trusted
              affiliates and advertisers for the purposes outlined above. We may
              use third party service providers to help us operate our business
              and the Site or administer activities on our behalf, such as
              sending out newsletters or surveys. We may share your information
              with these third parties for those limited purposes provided that
              you have given us your permission. All the above categories
              exclude text messaging originator opt-in data and consent; this
              information will not be shared with any third parties.
            </div>
          </div>
          <div className="common-point-container">
            <div className="privacy-policy-normal-title">
              Third party websites
            </div>
            <div className="privacy-policy-description">
              Users may find content on our Site that links to third parties. We
              do not control the content or links that appear on these sites and
              are not responsible for the practices employed by websites linked
              to or from our Site. In addition, these sites or services,
              including their content and links, may be constantly changing.
              These sites and services may have their own privacy policies and
              customer service policies. Browsing and interaction on any other
              website, including websites which have a link to our Site, is
              subject to that website’s own terms and policies.
            </div>
          </div>
          <div className="common-point-container">
            <div className="privacy-policy-normal-title">
              Changes to this privacy policy
            </div>
            <div className="privacy-policy-description">
              <strong>Hussme </strong>has the discretion to update this
              privacy policy at any time. When we do, we will revise the updated
              date at the bottom of this page. We encourage Users to frequently
              check this page for any changes to stay informed about how we are
              helping to protect the personal information we collect. You
              acknowledge and agree that it is your responsibility to review
              this privacy policy periodically and become aware of
              modifications.
              <div className="privacy-policy-subheading">
                Your acceptance of these terms
              </div>
              <br />
              By using this Site, you signify your acceptance of this policy. If
              you do not agree to this policy, please do not use our Site. Your
              continued use of the Site following the posting of changes to this
              policy will be deemed your acceptance of those changes. <br />
              <div className="privacy-policy-subheading">
                Contacting us
              </div>{" "}
              <br />
              If you have any questions about this Privacy Policy, the practices
              of this site, or your dealings with this site, please contact us
              here.
            </div>
          </div>
          <div className="privacy-policy-light-line-row"></div>
          <div className="privacy-policy-final-container">
            <div className="privacy-policy-bold-title">Refund policy</div>
            <div className="privacy-policy-description">
              Once you have paid, and completed the 14 day money back guarantee
              period there are no refunds. Throughout these terms and
              conditions, it is explained that due to the nature of working on
              third party platforms, disconnections, clients not checking our
              work on time, the fact that we are a month to month subscription
              service (and not a full service agency) there are absolutely no
              refunds. In the event we fail to create at least one post per
              week, you agree to accept a credit in the amount of the value of
              that post.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
